/** @jsx h */
import { h } from 'preact'

const FeedbackOption = ({ id, value }) =>
  <li class='Form-itemGroupItem Feedback-option'>
    <input
      autocomplete='off'
      type='checkbox'
      class='check_boxes optional Form-control--checkbox Form-control'
      id={id}
      value={value}
    />
    <label
      class='collection_check_boxes Feedback-label'
      for={id}
    >
      {value}
    </label>
  </li>

export default FeedbackOption
